import type React from 'react';
import { useEffect } from 'react';

import { OnboardingProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

const FcaQuestionnaireLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(OnboardingProgressStep.PERSONAL_INFORMATION, 0.9);
  }, [setCurrentStep]);

  return <BaseLayout {...props} />;
};
FcaQuestionnaireLayout.displayName = 'FcaQuestionnaireLayout';

export default FcaQuestionnaireLayout;
